import React from 'react';
import { Link } from 'react-router-dom'
import { SearchBoard } from './searchBoard';

import './boardAdmin.scss'

export const AdminBoard = () => {
  return (
    <section className="container-page">
      <div className="admin-board-container">
        <div className="box_ttl_opt mb-0">
          <h2 className="mb-0 text fnt_medium">Reconocimiento</h2>
          <div className="box_actions">
            <Link className="link_data" to="/details-category">
              <button type="button" className="btn secundary">
                <i className="fas fa-plus"></i> Nueva categoría
              </button>
            </Link>
          </div>
        </div>
        <div className="box_ttl_opt">
          <h6 className="mb-0 text-muted">Administrador</h6>
        </div>
      </div>
      <div>
        <SearchBoard />
      </div>
    </section>
  );
}
